export default "__VITE_ASSET__ee2479ae__"